export const scrollAttachTable = (currentPage: number, newPage: number) => {
  if (currentPage !== newPage) {
    document.querySelector('.attachmentsTableWrap')?.scrollTo(0, 0);
  }
};
